import React from 'react';
import { Modal } from '../Modal';
import { useTourStore } from 'src/store/tour';
import { TourStep } from './tour-step/TourStep';
import './TourGuide.scss';

export const TourGuide: React.FC = () => {
  const { 
    isTourGuideOpen,
    currentStep,
    totalSteps,
    startTour,
    setDontShowAgain,
    closeTourGuide,
    checkShouldShowTour,
  } = useTourStore();

  const handleDontShowAgain = () => {
    setDontShowAgain();
  };

  // Don't render if tour should not be shown
  if (!isTourGuideOpen || !checkShouldShowTour()) {
    return null;
  }

  return (
    <Modal isOpen={isTourGuideOpen} onClose={closeTourGuide} className={`tour-guide-modal`}>
      {currentStep === 1 ? (
        <div className="tour-guide">
          <div className="tour-guide__image">
            <img 
              src="/images/modalTourGuide.jpg"
              alt="Tour guide"
              className="tour-guide__image-content"
            />
            <h2 className="tour-guide__title">
              Nice to have you aboard!
            </h2>
          </div>
          <div className="tour-guide__content">          
            <div className="tour-guide__text">
              <p className="tour-guide__paragraph">
                This quick guide will show you the key parts of the interface so you can get comfortable fast. If you already feel confident, you can close the guide anytime and jump right in.
              </p>
            </div>

            <div className="tour-guide__actions">
              <button 
                className="tour-guide__button tour-guide__button--primary"
                onClick={startTour}
              >
                Start
              </button>
            </div>
            <button 
              className="tour-guide__dont-show"
              onClick={handleDontShowAgain}
            >
              Don't show again
            </button>
            <div className="tour-guide__progress">
              {currentStep}/{totalSteps}
            </div>
          </div>
        </div>
      ) : (
        <TourStep />
      )}
    </Modal>
  );
};
